import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  id: "formulario",
  class: "bg-[radial-gradient(ellipse_at_center,#0d9488_0%,#0b766c_100%)] p-6 plex-regular"
}
const _hoisted_2 = { class: "container mx-auto max-w-7xl bg-white bg-opacity-85 rounded-lg p-6" }
const _hoisted_3 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0" }
const _hoisted_4 = { class: "w-full px-2 md:w-1/5" }
const _hoisted_5 = { class: "text-sm text-red-500 p-error" }
const _hoisted_6 = { class: "w-full px-2 md:w-2/5" }
const _hoisted_7 = { class: "text-sm text-red-500 p-error" }
const _hoisted_8 = { class: "w-full px-2 md:w-2/5" }
const _hoisted_9 = { class: "text-sm text-red-500 p-error" }
const _hoisted_10 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_11 = { class: "w-full px-2 md:w-5/12" }
const _hoisted_12 = { class: "text-sm text-red-500" }
const _hoisted_13 = { class: "w-full px-2 md:w-5/12" }
const _hoisted_14 = { class: "text-sm text-red-500 p-error" }
const _hoisted_15 = { class: "w-full px-2 md:w-2/12" }
const _hoisted_16 = { class: "text-sm text-red-500 p-error" }
const _hoisted_17 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_18 = { class: "w-full px-2 md:w-3/12" }
const _hoisted_19 = { class: "w-full px-2 md:w-3/12" }
const _hoisted_20 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_21 = { class: "text-sm text-red-500 p-error" }
const _hoisted_22 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mb-4" }
const _hoisted_23 = { class: "w-full px-2 space-x-2" }
const _hoisted_24 = { class: "text-sm text-red-500 p-error" }
const _hoisted_25 = {
  key: 0,
  class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0"
}
const _hoisted_26 = { class: "w-full px-2" }
const _hoisted_27 = { class: "text-sm text-red-500 p-error" }
const _hoisted_28 = {
  key: 1,
  class: "w-full my-6 py-2 px-4 bg-[#25847A] text-white rounded-lg"
}
const _hoisted_29 = {
  key: 2,
  class: "w-full my-6 py-2 px-4 bg-[#25847A] text-white rounded-lg"
}
const _hoisted_30 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0" }
const _hoisted_31 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_32 = { class: "text-sm text-red-500 p-error" }
const _hoisted_33 = {
  key: 0,
  class: "w-full px-2 md:w-4/12"
}
const _hoisted_34 = { class: "text-sm text-red-500 p-error" }
const _hoisted_35 = {
  key: 1,
  class: "w-full px-2 md:w-4/12"
}
const _hoisted_36 = { class: "text-sm text-red-500 p-error" }
const _hoisted_37 = {
  key: 2,
  class: "w-full px-2 md:w-4/12"
}
const _hoisted_38 = { class: "text-sm text-red-500 p-error" }
const _hoisted_39 = {
  key: 3,
  class: "w-full px-2 md:w-4/12"
}
const _hoisted_40 = { class: "text-sm text-red-500 p-error" }
const _hoisted_41 = {
  key: 3,
  class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3"
}
const _hoisted_42 = { class: "w-full px-2 md:w-9/12" }
const _hoisted_43 = { class: "text-sm text-red-500 p-error" }
const _hoisted_44 = { class: "w-full px-2 md:w-3/12" }
const _hoisted_45 = { class: "text-sm text-red-500 p-error" }
const _hoisted_46 = {
  key: 4,
  class: "w-full my-6 py-2 px-4 bg-[#25847A] text-white rounded-lg"
}
const _hoisted_47 = {
  key: 5,
  class: "w-full my-6 py-2 px-4 bg-[#25847A] text-white rounded-lg"
}
const _hoisted_48 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0" }
const _hoisted_49 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_50 = { class: "text-sm text-red-500 p-error" }
const _hoisted_51 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_52 = { class: "text-sm text-red-500 p-error" }
const _hoisted_53 = {
  key: 6,
  class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3"
}
const _hoisted_54 = { class: "w-full px-2" }
const _hoisted_55 = { class: "text-sm text-red-500 p-error" }
const _hoisted_56 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_57 = { class: "w-full px-2" }
const _hoisted_58 = { class: "text-sm text-red-500 p-error" }
const _hoisted_59 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_60 = { class: "w-full px-2" }
const _hoisted_61 = { class: "text-sm text-red-500 p-error" }
const _hoisted_62 = { class: "w-full mx-auto font-chevy-regular space-y-5 mt-3" }
const _hoisted_63 = { class: "flex flex-wrap -mx-2 space-y-4" }
const _hoisted_64 = { class: "w-full px-2 space-x-2" }
const _hoisted_65 = { class: "text-sm text-red-500 p-error" }
const _hoisted_66 = { class: "flex flex-wrap py-2 mt-3" }
const _hoisted_67 = ["disabled"]
const _hoisted_68 = { class: "pi pi-spin pi-spinner mr-2" }
const _hoisted_69 = { class: "pi pi-check mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_InputMask = _resolveComponent("InputMask")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Form = _resolveComponent("Form")!
  const _component_FullScreenLoader = _resolveComponent("FullScreenLoader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_Form, {
        onSubmit: _ctx.onSubmit,
        "validation-schema": _ctx.schema,
        class: "space-y-4 text-gray-700",
        onInvalidSubmit: _ctx.onInvalidSubmit
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _cache[55] || (_cache[55] = _createElementVNode("div", { class: "w-full py-6 text-center" }, [
              _createElementVNode("h1", { class: "plex-semibold text-xl text-gray-800" }, "Pre-acreditate a BIMM 2026"),
              _createElementVNode("h1", { class: "plex-semibold text-xl text-gray-800" }, "El motor de la industria metalmecánica"),
              _createElementVNode("br"),
              _createElementVNode("h1", { class: "text-md md:text-xl text-gray-800" }, "28, 29 y 30 de mayo"),
              _createElementVNode("h1", { class: "text-md md:text-xl text-gray-800" }, "Jueves y Viernes de 11:00 a 19:00 hs, Sábado de 10:00 a 18:00 hs"),
              _createElementVNode("h1", { class: "text-md md:text-xl text-gray-800" }, "Centro de eventos Forja, Ciudad de Córdoba"),
              _createElementVNode("br"),
              _createElementVNode("h1", { class: "plex-semibold text-gray-800" }, "Por favor complete el formulario en su totalidad")
            ], -1)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _cache[24] || (_cache[24] = _createElementVNode("label", { class: "block mb-1" }, "DNI", -1)),
                _createVNode(_component_Field, {
                  name: "dni",
                  modelValue: _ctx.formData.dni,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.dni) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "numeric",
                      onBlur: _ctx.validarDni,
                      placeholder: "DNI",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                    }), null, 16, ["onBlur", "class"]),
                    _createElementVNode("span", _hoisted_5, [
                      _createVNode(_component_ErrorMessage, { name: "dni" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[25] || (_cache[25] = _createElementVNode("label", { class: "block mb-1" }, "Nombre", -1)),
                _createVNode(_component_Field, {
                  name: "nombre",
                  modelValue: _ctx.formData.nombre,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.nombre) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Nombre",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_7, [
                      _createVNode(_component_ErrorMessage, { name: "nombre" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[26] || (_cache[26] = _createElementVNode("label", { class: "block mb-1" }, "Apellido", -1)),
                _createVNode(_component_Field, {
                  name: "apellido",
                  modelValue: _ctx.formData.apellido,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.apellido) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Apellido",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_9, [
                      _createVNode(_component_ErrorMessage, { name: "apellido" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[27] || (_cache[27] = _createElementVNode("label", { class: "block mb-1" }, "E-mail", -1)),
                _createVNode(_component_Field, {
                  name: "mail",
                  modelValue: _ctx.formData.mail,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.mail) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "E-mail",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_12, [
                      _createVNode(_component_ErrorMessage, { name: "mail" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _cache[28] || (_cache[28] = _createElementVNode("label", { class: "block mb-1" }, "Confirme su E-mail", -1)),
                _createVNode(_component_Field, {
                  name: "mailConfirmacion",
                  modelValue: _ctx.formData.mailConfirmacion,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.mailConfirmacion) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Confirme su E-mail",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_14, [
                      _createVNode(_component_ErrorMessage, { name: "mailConfirmacion" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _cache[29] || (_cache[29] = _createElementVNode("label", { class: "block mb-1" }, "Fecha de nacimiento", -1)),
                _createVNode(_component_Field, {
                  name: "fechaNacimiento",
                  modelValue: _ctx.formData.fechaNacimiento,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.fechaNacimiento) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputMask, _mergeProps(field, {
                      mask: "99/99/9999",
                      placeholder: "dd/mm/yyyy",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_16, [
                      _createVNode(_component_ErrorMessage, { name: "fechaNacimiento" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _cache[30] || (_cache[30] = _createElementVNode("label", { class: "block mb-1" }, "País (Teléfono)", -1)),
                _createVNode(_component_Select, {
                  modelValue: _ctx.selectedCountry,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedCountry) = $event)),
                  filter: "",
                  options: _ctx.paises,
                  optionLabel: "descripcion",
                  placeholder: "Select a Country",
                  class: "input-base input-success"
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _cache[31] || (_cache[31] = _createElementVNode("label", { class: "block mb-1" }, "Código de país", -1)),
                (_ctx.selectedCountry !== null)
                  ? (_openBlock(), _createBlock(_component_InputText, {
                      key: 0,
                      type: "text",
                      modelValue: _ctx.selectedCountry.id,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedCountry.id) = $event)),
                      class: "input-base input-success",
                      readonly: ""
                    }, null, 8, ["modelValue"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _cache[32] || (_cache[32] = _createElementVNode("label", { class: "block mb-1" }, "Teléfono celular", -1)),
                _createVNode(_component_Field, {
                  name: "telefonoCelular",
                  modelValue: _ctx.formData.telefonoCelular,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.telefonoCelular) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Teléfono celular",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_21, [
                      _createVNode(_component_ErrorMessage, { name: "telefonoCelular" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _cache[56] || (_cache[56] = _createElementVNode("div", { class: "w-full my-6 py-2 px-4 bg-[#25847A] text-white rounded-lg" }, [
              _createElementVNode("h1", { class: "plex-semibold text-xl" }, "DATOS DE LA EMPRESA")
            ], -1)),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_Field, {
                  name: "sinEmpresa",
                  modelValue: _ctx.formData.sinEmpresa,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.sinEmpresa) = $event))
                }, {
                  default: _withCtx(({ handleChange, handleBlur, value }) => [
                    _createVNode(_component_Checkbox, {
                      checked: value,
                      "onUpdate:modelValue": handleChange,
                      onBlur: handleBlur,
                      size: "large",
                      inputId: "sinEmpresa",
                      binary: ""
                    }, null, 8, ["checked", "onUpdate:modelValue", "onBlur"]),
                    _cache[34] || (_cache[34] = _createElementVNode("label", {
                      for: "sinEmpresa",
                      class: "cursor-pointer"
                    }, "No pertenezco a una empresa", -1)),
                    _createElementVNode("span", _hoisted_24, [
                      _cache[33] || (_cache[33] = _createElementVNode("br", null, null, -1)),
                      _createVNode(_component_ErrorMessage, { name: "sinEmpresa" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            (!_ctx.formData.sinEmpresa)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _cache[35] || (_cache[35] = _createElementVNode("label", { class: "block mb-1" }, "Razón social de la empresa", -1)),
                    _createVNode(_component_Field, {
                      name: "empresa",
                      modelValue: _ctx.formData.empresa,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.empresa) = $event))
                    }, {
                      default: _withCtx(({ field, errors }) => [
                        _createVNode(_component_InputText, _mergeProps(field, {
                          type: "text",
                          placeholder: "Empresa",
                          class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                        }), null, 16, ["class"]),
                        _createElementVNode("span", _hoisted_27, [
                          _createVNode(_component_ErrorMessage, { name: "empresa" })
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.formData.sinEmpresa)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [...(_cache[36] || (_cache[36] = [
                  _createElementVNode("h1", { class: "plex-semibold text-lg" }, "DOMICILIO DE LA EMPRESA", -1)
                ]))]))
              : (_openBlock(), _createElementBlock("div", _hoisted_29, [...(_cache[37] || (_cache[37] = [
                  _createElementVNode("h1", { class: "plex-semibold text-lg" }, "LUGAR DE ORIGEN", -1)
                ]))])),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _cache[38] || (_cache[38] = _createElementVNode("label", { class: "block mb-1" }, "País", -1)),
                _createVNode(_component_Field, {
                  name: "paisEmpresa",
                  modelValue: _ctx.formData.paisEmpresa,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.paisEmpresa) = $event))
                }, {
                  default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                    _createVNode(_component_Select, {
                      filter: "",
                      onBlur: handleBlur,
                      "onUpdate:modelValue": handleChange,
                      "model-value": value,
                      class: _normalizeClass([{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }, "input-base"]),
                      placeholder: "País de residencia",
                      options: _ctx.paises,
                      optionLabel: "descripcion"
                    }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "class", "options"]),
                    _createElementVNode("span", _hoisted_32, [
                      _createVNode(_component_ErrorMessage, { name: "paisEmpresa" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              (_ctx.formData.paisEmpresa?.id == '+54')
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _cache[39] || (_cache[39] = _createElementVNode("label", { class: "block mb-1" }, "Provincia", -1)),
                    _createVNode(_component_Field, {
                      name: "provincia",
                      modelValue: _ctx.formData.provincia,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.provincia) = $event))
                    }, {
                      default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                        _createVNode(_component_Select, {
                          onBlur: handleBlur,
                          "onUpdate:modelValue": handleChange,
                          "model-value": value,
                          placeholder: "Seleccione la provincia",
                          options: _ctx.provincias,
                          optionLabel: "descripcion",
                          class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }])
                        }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                        _createElementVNode("span", _hoisted_34, [
                          _createVNode(_component_ErrorMessage, { name: "provincia" })
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.formData.paisEmpresa?.id != '+54')
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _cache[40] || (_cache[40] = _createElementVNode("label", { class: "block mb-1" }, "Provincia / Estado", -1)),
                    _createVNode(_component_Field, {
                      name: "provinciaEstado",
                      modelValue: _ctx.formData.provinciaEstado,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.provinciaEstado) = $event))
                    }, {
                      default: _withCtx(({ field, errors }) => [
                        _createVNode(_component_InputText, _mergeProps(field, {
                          type: "text",
                          placeholder: "Ingrese su provincia o estado",
                          class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                        }), null, 16, ["class"]),
                        _createElementVNode("span", _hoisted_36, [
                          _createVNode(_component_ErrorMessage, { name: "provinciaEstado" })
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.formData.paisEmpresa?.id == '+54')
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    _cache[41] || (_cache[41] = _createElementVNode("label", { class: "block mb-1" }, "Localidad", -1)),
                    _createVNode(_component_Field, {
                      name: "localidad",
                      modelValue: _ctx.formData.localidad,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.localidad) = $event))
                    }, {
                      default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                        _createVNode(_component_Select, {
                          onBlur: handleBlur,
                          filter: "",
                          "onUpdate:modelValue": handleChange,
                          "model-value": value,
                          placeholder: "Seleccione la localidad",
                          class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }]),
                          options: _ctx.localidades,
                          optionLabel: "descripcion"
                        }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                        _createElementVNode("span", _hoisted_38, [
                          _createVNode(_component_ErrorMessage, { name: "localidad" })
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.formData.paisEmpresa?.id != '+54')
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _cache[42] || (_cache[42] = _createElementVNode("label", { class: "block mb-1" }, "Localidad / Ciudad", -1)),
                    _createVNode(_component_Field, {
                      name: "localidadCiudad",
                      modelValue: _ctx.formData.localidadCiudad,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.localidadCiudad) = $event))
                    }, {
                      default: _withCtx(({ field, errors }) => [
                        _createVNode(_component_InputText, _mergeProps(field, {
                          type: "text",
                          placeholder: "Ingrese su localidad o ciudad",
                          class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                        }), null, 16, ["class"]),
                        _createElementVNode("span", _hoisted_40, [
                          _createVNode(_component_ErrorMessage, { name: "localidadCiudad" })
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            (!_ctx.formData.sinEmpresa)
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _cache[43] || (_cache[43] = _createElementVNode("label", { class: "block mb-1" }, "Dirección", -1)),
                    _createVNode(_component_Field, {
                      name: "direccion",
                      modelValue: _ctx.formData.direccion,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.direccion) = $event))
                    }, {
                      default: _withCtx(({ field, errors }) => [
                        _createVNode(_component_InputText, _mergeProps(field, {
                          type: "text",
                          placeholder: "Dirección",
                          class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                        }), null, 16, ["class"]),
                        _createElementVNode("span", _hoisted_43, [
                          _createVNode(_component_ErrorMessage, { name: "direccion" })
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _cache[44] || (_cache[44] = _createElementVNode("label", { class: "block mb-1" }, "Código Postal", -1)),
                    _createVNode(_component_Field, {
                      name: "codigoPostal",
                      modelValue: _ctx.formData.codigoPostal,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.codigoPostal) = $event))
                    }, {
                      default: _withCtx(({ field, errors }) => [
                        _createVNode(_component_InputText, _mergeProps(field, {
                          type: "text",
                          placeholder: "Dirección",
                          class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                        }), null, 16, ["class"]),
                        _createElementVNode("span", _hoisted_45, [
                          _createVNode(_component_ErrorMessage, { name: "codigoPostal" })
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.formData.sinEmpresa)
              ? (_openBlock(), _createElementBlock("div", _hoisted_46, [...(_cache[45] || (_cache[45] = [
                  _createElementVNode("h1", { class: "plex-semibold text-lg" }, "OTROS DATOS DE LA EMPRESA", -1)
                ]))]))
              : (_openBlock(), _createElementBlock("div", _hoisted_47, [...(_cache[46] || (_cache[46] = [
                  _createElementVNode("h1", { class: "plex-semibold text-lg" }, "OTROS DATOS", -1)
                ]))])),
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _cache[47] || (_cache[47] = _createElementVNode("label", { class: "block mb-1" }, "Sitio web", -1)),
                _createVNode(_component_Field, {
                  name: "website",
                  modelValue: _ctx.formData.website,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.website) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Sitio web",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_50, [
                      _createVNode(_component_ErrorMessage, { name: "website" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _cache[48] || (_cache[48] = _createElementVNode("label", { class: "block mb-1" }, "Actividad", -1)),
                _createVNode(_component_Field, {
                  name: "actividad",
                  modelValue: _ctx.formData.actividad,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formData.actividad) = $event))
                }, {
                  default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                    _createVNode(_component_Select, {
                      onBlur: handleBlur,
                      "onUpdate:modelValue": handleChange,
                      "model-value": value,
                      placeholder: "Seleccione la actividad",
                      options: _ctx.actividades,
                      optionLabel: "descripcion",
                      class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }])
                    }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                    _createElementVNode("span", _hoisted_52, [
                      _createVNode(_component_ErrorMessage, { name: "actividad" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            (!_ctx.formData.sinEmpresa)
              ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    _cache[49] || (_cache[49] = _createElementVNode("label", { class: "block mb-1" }, "Función en la empresa", -1)),
                    _createVNode(_component_Field, {
                      name: "funcion",
                      modelValue: _ctx.formData.funcion,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.funcion) = $event))
                    }, {
                      default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                        _createVNode(_component_Select, {
                          onBlur: handleBlur,
                          "onUpdate:modelValue": handleChange,
                          "model-value": value,
                          placeholder: "Seleccione su función",
                          options: _ctx.funciones,
                          optionLabel: "descripcion",
                          class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }])
                        }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                        _createElementVNode("span", _hoisted_55, [
                          _createVNode(_component_ErrorMessage, { name: "funcion" })
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("div", _hoisted_57, [
                _cache[50] || (_cache[50] = _createElementVNode("label", { class: "block mb-1" }, "Seleccione los sectores de interés", -1)),
                _createVNode(_component_Field, {
                  name: "sectoresInteres",
                  modelValue: _ctx.formData.sectoresInteres,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formData.sectoresInteres) = $event))
                }, {
                  default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                    _createVNode(_component_MultiSelect, {
                      onBlur: handleBlur,
                      "onUpdate:modelValue": handleChange,
                      "model-value": value,
                      placeholder: "Seleccione los sectores de interés",
                      class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}]),
                      options: _ctx.sectores,
                      optionLabel: "descripcion"
                    }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                    _createElementVNode("span", _hoisted_58, [
                      _createVNode(_component_ErrorMessage, { name: "sectoresInteres" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("div", _hoisted_60, [
                _cache[51] || (_cache[51] = _createElementVNode("label", { class: "block mb-1" }, "¿Cómo conoció BIMM?", -1)),
                _createVNode(_component_Field, {
                  name: "tipoContacto",
                  modelValue: _ctx.formData.tipoContacto,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formData.tipoContacto) = $event))
                }, {
                  default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                    _createVNode(_component_Select, {
                      onBlur: handleBlur,
                      "onUpdate:modelValue": handleChange,
                      "model-value": value,
                      placeholder: "Seleccione como nos conoció",
                      options: _ctx.tiposContactos,
                      optionLabel: "descripcion",
                      class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }])
                    }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                    _createElementVNode("span", _hoisted_61, [
                      _createVNode(_component_ErrorMessage, { name: "tipoContacto" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("div", _hoisted_64, [
                  _createVNode(_component_Field, {
                    name: "aceptoNoMenores",
                    modelValue: _ctx.formData.aceptoNoMenores,
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formData.aceptoNoMenores) = $event))
                  }, {
                    default: _withCtx(({ handleChange, handleBlur, value }) => [
                      _createVNode(_component_Checkbox, {
                        checked: value,
                        "onUpdate:modelValue": handleChange,
                        onBlur: handleBlur,
                        size: "large",
                        inputId: "aceptoNoMenores",
                        binary: ""
                      }, null, 8, ["checked", "onUpdate:modelValue", "onBlur"]),
                      _cache[53] || (_cache[53] = _createElementVNode("label", {
                        for: "aceptoNoMenores",
                        class: "cursor-pointer"
                      }, "Acepto no asistir con menores de 16 años al evento.", -1)),
                      _createElementVNode("span", _hoisted_65, [
                        _cache[52] || (_cache[52] = _createElementVNode("br", null, null, -1)),
                        _createVNode(_component_ErrorMessage, { name: "aceptoNoMenores" })
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_66, [
              _createElementVNode("button", {
                type: "submit",
                class: "mt-4 px-4 py-2 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded",
                disabled: _ctx.isSubmitting
              }, [
                _withDirectives(_createElementVNode("i", _hoisted_68, null, 512), [
                  [_vShow, _ctx.isSubmitting]
                ]),
                _withDirectives(_createElementVNode("i", _hoisted_69, null, 512), [
                  [_vShow, !_ctx.isSubmitting]
                ]),
                _cache[54] || (_cache[54] = _createTextVNode("REGISTRARME ", -1))
              ], 8, _hoisted_67)
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema", "onInvalidSubmit"])
    ]),
    _createVNode(_component_FullScreenLoader, {
      visible: _ctx.isSubmitting,
      fullScreen: ""
    }, null, 8, ["visible"])
  ], 64))
}